import { toast } from "sonner";

export function showUploadToast({ type = "info", title, subtitle, details = [] }) {
    // default fallback if not in an array or unavailable
    if (!Array.isArray(details) || details.length === 0) {
        toast[type](title, { description: subtitle });
        return;
    }

    toast[type](
      <div>
        <div className="font-medium text-sm">{subtitle}</div>
        <div className="mt-2 text-xs max-h-[120px] overflow-y-auto space-y-1 pr-1">
          {details.slice(0, 4).map((d, idx) => (
            <div key={idx} className="text-white/80">
              {typeof d === "string" ? d : d.message}
            </div>
          ))}
          {details.length > 4 && (
            <div className="text-white/60">+{details.length - 4} more…</div>
          )}
        </div>
      </div>,
      {
        duration: 7000,
        dismissible: true,
      }
    );
};